module.exports = __webpack_public_path__ + "static/media/facebook.80e6fa2d.svg";